export type Colors = typeof colors;
export const wcagColors = {
  /**
   * The purpose of that object is to create WCAG-compliant color palette. For now,
   * significant tokens are adjusted to one color to keep semantic context.
   * It's a matter of adjusting when we will come up with new design system or
   * compliant color palette
   */
  grey: '#949494',
} as const;

export const colors = {
  black: '#000000',
  // used for misc text color/background
  neutral35: '#6E6E6E',
  neutral40: '#666666',
  // used for various button/checkbox/radio hovers
  neutral75: '#BBBBBB',
  // radio/checkbox input border + icons fill fallback
  neutral80: '#CCCCCC',
  // input/buttons borders
  neutral85: '#D6D6D6',
  // layout borders/dividers color + default spiner color
  neutral90: '#E6E6E6',
  // other layout borders/dividers
  neutral91: '#E8E8E8',
  // return and exchange component background
  neutral94: '#F3F3F3',
  // custom category text background
  neutral95: '#F4F4F4',
  // active select option background
  neutral99: '#FCFCFC',
  white: '#FFFFFF',
  error35: '#EE0000',
  fullscreenBackgroundColor: 'rgba(24, 27, 27, 0.8)',
  green: '#008A27',
  superlightOrange: '#FFF9F0',
  darkOrange: '#EE9100',
  overlayBackgroundColor: 'rgba(0, 0, 0, 0.2)',
  darkGrey: '#767676',
  grey: '#999999',
  superlightGrey: '#F7F7F7',
} as const;
